// extracted by mini-css-extract-plugin
export default {"logo":"liquidity-card-title_logo__P1mDh","icon":"liquidity-card-title_icon__v7DL0"};